/**
 *
 *
 *
 *
 *
 *
 */
import { otto } from "./nexus.js";
import { apmSync, type ApmAsync } from "../globals/apm.js";

export type {
  ApmDefaultLabels,
  APMLabelsMap,
  CaptureErrorOptions,
} from "../lib/apm/async/captureError.js";

/**
 *
 */
export const apm: ApmAsync = otto.apm;
/*                */
export { apmSync };

/**
 *
 *
 *
 */
export const agent: ApmAsync["agent"] = apm.agent;

/**
 *
 *
 *
 *
 */
export const isActive: ApmAsync["isActive"] = apm.isActive;

/**
 *
 *
 *
 */
export const getCurrentTransaction: ApmAsync["getCurrentTransaction"] = apm.getCurrentTransaction;

/**
 *
 *
 *
 */
export const startSpan: ApmAsync["startSpan"] = apm.startSpan;

/**
 *
 *
 *
 *
 */
export const captureError: ApmAsync["captureError"] = apm.captureError;

/**
 *
 *
 *
 */
export const mark: ApmAsync["mark"] = apm.mark;

/**
 *
 *
 *
 */
export const addLabels: ApmAsync["addLabels"] = apm.addLabels;

/**
 *
 */
export const sendCustomError: ApmAsync["sendCustomError"] = apm.sendCustomError;

/**
 *
 *
 *
 */
export const instrument = apmSync.instrument;

/**
 *
 *
 *
 */
export const runInstrumented = apmSync.runInstrumented;

/**
 *
 */
export const withSpan = apmSync.withSpan;

/**
 *
 */
export const runWithSpan = apmSync.runWithSpan;
